import request from '@/utils/httpRequest'

export default class InvoiceService {
	
	list (params) {
		return request({
			url: '/invoice/list',
			method: 'get',
			params: params
		})
	}
	
	upload (inputForm) {
		return request({
			url: '/common/upload',
			method: 'post',
			data: inputForm
		})
	}
 
	multipleInvoice (params) {
		return request({
			url: '/invoice/multipleInvoice',
			method: 'get',
			params: params
		})
	}
	
	saveBill (inputForm) {
		return request({
			url: '/invoice/saveBill',
			headers: {
				'Content-Type':'application/x-www-form-urlencoded; charset=utf-8',
			},
			method: 'post',
			data: inputForm
		})
	}

	editBill(params){
		return request({
			url: '/invoice/updateInvoice',
			method: 'post',
			headers: {
				'Content-Type':'application/x-www-form-urlencoded; charset=utf-8',
			},
			data: params
		})
	}

	deleteBill (params) {
		return request({
			url: '/invoice/removeBill',
			method: 'post',
			data: params
		})
	}

	expenseList (params) {
		return request({
			url: '/cost/invoice/expenseList',
			method: 'get',
			params: params
		})
	}

	confirmExpense (params) {
		return request({
			url: '/cost/invoice/relBusiness',
			method: 'post',
			data: params
		})
	}

	myExpenseList (params) {
		return request({
			url: '/cost/invoice/myExpenseList',
			method: 'get',
			params: params
		})
	}

	queryBill (params) {
		return request({
			url: '/invoice/getBillInfo',
			method: 'get',
			params: params
		})
	}
 
}
